import React from 'react';
import { connect } from 'react-redux';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import PropTypes from 'prop-types';

import { updateMessageStatusRequest, messageStatusAction } from '../redux/reducers/message';
import { getTeamMembersFullRequest, selectMessage, resetSelectionMessage } from '../redux/reducers/teamMembersFull';
import { toggleViewMessage, toggleComposeMessage } from '../redux/reducers/view';
import { messagesListRequest, showMessageCenter, messagesSentRequest } from '../redux/reducers/messagesList';
import { getUsersMessageList, getUsersMessageSent } from '../redux/selectors';

import { STATUSES } from '../constants';

import AvatarCirce from './AvatarCircle';

import { commonStyles, COLORS } from '../styles/styles';
import { MESSAGE_TYPES } from '../constants';

import { convertTime, getExcerptTL } from '../utils';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBCol,
  MDBAnimation,
  MDBBadge,
  MDBIcon} from "mdbreact";
import LearnerMessageContent from './LearnerMessageContent';
import MessageCompose from './MessageCompose';
import { announcementsRequest } from '../redux/reducers/announcements';
import { xapiRequest } from '../redux/reducers/xapi';

  const getStatusClass = id => {
    for (let i = 0; i < MESSAGE_TYPES.length; i++) {
      const element = MESSAGE_TYPES[i];
      if(element.id===id){
        return element
      }
      
    }
  return {color:'danger-color', name:'none'}
  };

const MessageList = ({ classes, messageList, notNewMessages, onMessageClick, teamMembersFull,toggleActiveTab,
  activeItem, showMessageCenter, 
  viewMessage,
  setViewMessage,
  composeMessage,
  setComposeMessage,
  closeCompose,
  showMessageCenterNow,
  messageSentList
 }) => {
  const MessagesListRenderer = () => (
   <div>
      {messageList.map(item => {
        
        // const isRead = item.status === 'read' || notNewMessages.includes(item.id);
        // const isSelected = item.id === teamMembersFull.selectedMessageId;
        
        // const messageTitle =
        //   item.type.id === MESSAGE_TYPES.decline.id || item.type.id === MESSAGE_TYPES.invite.id
        //     ? '- INVITATION -'
        //     : item.content.name;
        const messageContent = getExcerptTL(item, MESSAGE_TYPES);
        
        const badges = getStatusClass(item.type.id)
        return (
          item &&
          item.status !== 'trash' && (
            <MDBCard  className="z-depth-2 rounded-0 pl-0 pr-0 pt-3 pb-3 noShadow" 
              style={{borderBottom: '1px solid #ededed', minHeight: 'auto'}}
              key={item.id}
              onClick={() => onMessageClick(item)}
            >
              <MDBRow style={{width:'100%', margin: '0 auto'}}>
                <MDBCol className="col-2">

                  {item.status=='new' &&  <div className='danger-color-dark' style={{height:10, width:10, borderRadius:10}}></div>}
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg" className="rounded-circle z-depth-0"
                            style={{ height: 45}} alt="" />
                </MDBCol>

                <MDBCol className="col-7 col-xs-10">
                  <Typography className={classes.senderName}>{item.sender.name}</Typography>
                  <Typography className={classes.messageListSubject}>{item.messageTitle}</Typography>
                  <Typography className={classes.messageListContent}>{messageContent}</Typography>
                </MDBCol>
                <MDBCol className="col-lg-3 col-xs-12 text-right">
                  <Typography className="floatLeftOnMobile text-right">
                    {convertTime(item.created_at.date)}
                  </Typography>
                  <MDBBadge style={{padding: '0.7em 1em 0.7em 1em', marginTop:'0.5em',minWidth:82}} pill color={badges.color} className='text-white floatRightOnMobile'>{badges.name}</MDBBadge>
                </MDBCol>
              </MDBRow>
            </MDBCard>
          )
        );
      })}
    </div>
  );

  const MessagesSentRenderer = () => (
    <div>
       {messageSentList.map(item => {
         
         // const isRead = item.status === 'read' || notNewMessages.includes(item.id);
         // const isSelected = item.id === teamMembersFull.selectedMessageId;
         
         // const messageTitle =
         //   item.type.id === MESSAGE_TYPES.decline.id || item.type.id === MESSAGE_TYPES.invite.id
         //     ? '- INVITATION -'
         //     : item.content.name;
         const messageContent = getExcerptTL(item, MESSAGE_TYPES);
         
         const badges = getStatusClass(item.type.id)
         return (
           item &&
           item.status !== 'trash' && (
             <MDBCard  className="z-depth-2 rounded-0 pl-0 pr-0 pt-3 pb-3 noShadow" 
               style={{borderBottom: '1px solid #ededed', minHeight: 'auto'}}
               key={item.id}
               onClick={() => onMessageClick(item)}
             >
               <MDBRow style={{width:'100%', margin: '0 auto'}}>
                 <MDBCol className="col-2">
 
                   
                   <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg" className="rounded-circle z-depth-0"
                             style={{ height: 45}} alt="" />
                 </MDBCol>
 
                 <MDBCol className="col-7 col-xs-10">
                   <Typography className={classes.senderName}>{item.sender.name}</Typography>
                   <Typography className={classes.messageListSubject}>{item.messageTitle}</Typography>
                   <Typography className={classes.messageListContent}>{messageContent}</Typography>
                 </MDBCol>
                 <MDBCol className="col-lg-3 col-xs-12 text-right">
                   <Typography className="floatLeftOnMobile text-right">
                     {convertTime(item.created_at.date)}
                   </Typography>
                   <MDBBadge style={{padding: '0.7em 1em 0.7em 1em', marginTop:'0.5em',minWidth:82}} pill color={badges.color} className='text-white floatRightOnMobile'>{badges.name}</MDBBadge>
                 </MDBCol>
               </MDBRow>
             </MDBCard>
           )
         );
       })}
     </div>
   );
  return <div>
    {showMessageCenter && <MDBCard  className="z-depth-5 rounded-0 float-right col-lg-6 col-md-6 p-0 fixedCard yellow-card" >
    
  <div className='gothamBlack text-dark text-left pt-3 pl-3'>
  <MDBIcon icon='times' className="primary-text" size="lg" style={{paddingRight:10}} onClick={()=>showMessageCenterNow(false)}/>
    MESSAGE CENTER
  </div>
  <MDBBtn
    floating
    right
    tag='a'
    className='ml-auto ml-4 deepDropShadow addBtn'
    action
    onClick={()=>setComposeMessage(true)}
  >
    <MDBIcon icon='plus' className="success-color" size="md"/>
  </MDBBtn>
  <div className="classic-tabs">
    <MDBNav classicTabs className="pt-2 mt-3" style={{backgroundColor:'#EBEBEB'}}  >
      <MDBNavItem>
        <MDBNavLink link to="#" active={activeItem==="1"} onClick={() => toggleActiveTab("1")}>
          INBOX
        </MDBNavLink>
      </MDBNavItem>
      <MDBNavItem>
        <MDBNavLink link to="#" active={activeItem==='2'} onClick={() => toggleActiveTab("2")}>
         SENT 
        </MDBNavLink>
      </MDBNavItem>
    </MDBNav>
    <MDBTabContent style={{backgroundColor:'#ffffff'}} className="p-0 contentScrollProg" activeItem={activeItem} >
      <MDBTabPane tabId="1">
      {MessagesListRenderer()}
      </MDBTabPane>
      <MDBTabPane tabId="2">
      {MessagesSentRenderer()}
      </MDBTabPane>
    </MDBTabContent>
</div>


</MDBCard>}
{viewMessage && <LearnerMessageContent setViewMessage={setViewMessage}/>}
{composeMessage && <MessageCompose closeCompose={closeCompose}/>}
</div>
};

const styles = () => ({
  ...commonStyles,
  messagesList: {
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
    margin: '0px -22px',
    padding: 0,
    overflow: 'auto',
  },
});

const mapStateToProps = state => ({
  messageList: getUsersMessageList(state),
  messageSentList: getUsersMessageSent(state),
  teamMembersFull: state.teamMembersFullReducer,
  showMessageCenter: state.messagesListReducer.showMessageCenterNow,
  messageSent: state.messagesListReducer.messageSent
});

const mapDispatchToProps = dispatch => ({
  updateMessageStatusRequest: message => dispatch(updateMessageStatusRequest(message)),
  messageStatusAction: action => dispatch(messageStatusAction(action)),
  selectMessage: messageId => dispatch(selectMessage(messageId)),
  toggleViewMessage: value => dispatch(toggleViewMessage(value)),
  toggleComposeMessage: flag => dispatch(toggleComposeMessage(flag)),
  messagesListRequest: () => dispatch(messagesListRequest()),
  messagesSentRequest: () => dispatch(messagesSentRequest()),
  announcementsRequest: () => dispatch(announcementsRequest()),
  showMessageCenterNow: bool => dispatch(showMessageCenter(bool)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
});

export default compose(
  withState('notNewMessages', 'changeMessageStatus', []),
  withState('activeItem','setActiveItem', '1'),
  withState('viewMessage','setViewMessage', false),
  withState('composeMessage','setComposeMessage', false),
 
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleChangeMessageStatus: props => itemId => {
      if (!props.notNewMessages.includes(itemId)) {
        props.changeMessageStatus([...props.notNewMessages, itemId]);
      }
    },
    toggleActiveTab: props => (tab) => {
      
      if (props.activeItem !== tab) {
        props.setActiveItem(tab)
      }
    },
    closeCompose: props => () => {
        props.setComposeMessage(false)
    },
  }),
  lifecycle({
    componentWillMount() {
      const { messagesListRequest, announcementsRequest, resetUserPrograms } = this.props;
     
    },
    componentWillReceiveProps(nextProps){
      const { messagesListRequest, announcementsRequest, resetUserPrograms, messagesSentRequest } = this.props;
      console.log('OOPP',nextProps.showMessageCenter,this.props.showMessageCenter)
      if(this.props.showMessageCenter==false && nextProps.showMessageCenter==true){
        messagesListRequest();
        messagesSentRequest();
        announcementsRequest();
      }
     
    }
  }),
  withHandlers({
    onMessageClick: props => item => {
      const {
        selectMessage,
        updateMessageStatusRequest,
        handleChangeMessageStatus,
        toggleViewMessage,
        toggleComposeMessage,
        getTeamMembersFullRequest,
        messageStatusAction,
        setViewMessage,
      } = props;
      selectMessage(item.id);
      if (item.status !== 'read') {
        if(item.status !== 'accept' && item.status !== 'decline'){
          messageStatusAction('read');
          updateMessageStatusRequest(item.id);
          handleChangeMessageStatus(item.id);
        }
        
        //getTeamMembersFullRequest();
       
      }
      //props.xapiRequest({ xapiType: `Read`});
      // toggleViewMessage(true);
      // toggleComposeMessage(false);
      setViewMessage(true);
    },
  }),
  withStyles(styles),
)(MessageList);

MessageList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  messageList: PropTypes.instanceOf(Array),
  notNewMessages: PropTypes.instanceOf(Array),
  onMessageClick: PropTypes.func,
  teamMembersFull: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Components/MessageList.jsx